import React, { useState } from 'react';
import { Modal } from '../../components/common/Modal';
import { RoastForm } from './component/RoastForm';
import { useLanguage } from '../../features/language/useLanguage';
import { usePermissions } from '../../hooks/usePermissions';

export const RoastingPage: React.FC = () => {
  const { t } = useLanguage();
  const { can } = usePermissions();
  const canWrite = can('work_orders.roasting', 'write');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenCreate = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };


  return (
    <div className='space-y-6'>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h1 className="text-2xl font-semibold text-gray-900">{t('roast.page.title')}</h1>
        {canWrite && (
          <button
            data-test-id="recipe-create-button"
            onClick={() => handleOpenCreate()}
            className="w-full sm:w-auto px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {t('roast.page.newRoast')}
          </button>
        )}
      </div>

      <Modal
        isOpen={isModalOpen}
         onClose={handleCloseModal}
         title={t('roast.page.createNewRoast')}
         className="max-w-7xl"
      >
        <RoastForm onSuccess={handleCloseModal} readOnly={!canWrite} />
      </Modal>
    </div>
  );
};
